(ns manage.ad-variant.creation.link.link-ad-variants-ocp
  (:require ["@mui/material/Box$default" :as Box]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/Grid$default" :as Grid]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            ["src/svg/artwork/connection-error.svg$default" :as ConnectionErrorIcon]
            ["src/svg/artwork/not-found.svg$default" :as NotFoundIcon]
            [common.ocp.view :refer [defocp ocp]]
            [common.patterns.empty-state-view :refer [empty-state-view]]
            [common.patterns.loading-view :refer [loading-view]]
            [common.queries :refer [use-mutation]]
            [manage.ad-variant.creation.link.hooks :as hooks]
            [manage.ad-variant.creation.link.ps-project-item :refer [ps-project-item]]
            [manage.ad-variant.creation.link.queries :as q]
            [re-frame.core :as rf]
            [uix.core :refer [$ defui use-effect use-state]]
            [uix.re-frame :refer [use-subscribe]]))

(defui ocp-footer
  [{:keys [link-adset selected]}]
  ($ Stack {:direction "row" :gap 1
            :justifyContent "flex-end"}
     ($ Button
        {:variant "text"
         :on-click #(rf/dispatch [:ocp/close {:id :ad-variants-link-ocp}])
         :data-testid "link-projects-cancel"}
        "Cancel")
     ($ Button
        {:type "submit"
         :variant "contained"
         :disabled (not (some? selected))
         :on-click #(link-adset (vec selected))
         :data-testid "link-projects-submit"}
        "Link")))

(defocp ad-variants-link-ocp :ad-variants-link-ocp
  {:width "40%"
   :disable-padding true
   :background-color "white"}
  []
  (let [{:keys [adset-id]} (use-subscribe [:url-context])

        [selected set-selected] (use-state #{})
        {:keys [status ps-status campaigns mapped-campaigns-ids
                refetch-available-third-party-projects]} (hooks/use-ps-campaigns)
        {link-adset :mutate} (use-mutation (q/adset-project-ids-mutation {:adset-id adset-id}))
        campaigns-count (count campaigns)]
    (use-effect
     (fn []
       (set-selected mapped-campaigns-ids))
     [mapped-campaigns-ids])
    ($ ocp
       {:title "Link adset"
        :footer ($ ocp-footer {:link-adset link-adset :selected selected})
        :on-submit #()}
       (cond
         ;; PS Not Ready: Show onboarding empty state
         (= ps-status :ps-not-ready)
         ($ empty-state-view
            {:artwork NotFoundIcon
             :title "Enable Assemble integration"
             :description "The integration with Assemble needs to be enabled for this project before you can map Assemble campaigns. Add Assemble to your project settings, and create at least one Assemble Campaign or click Learn More for a more detailed explanation on what is needed for this integration."
             :actions ($ Button
                         {:variant "contained"
                          :onClick refetch-available-third-party-projects}
                         "Retry")
             :docs-href "https://knowledge-base.wppopen.com/hc/en-us/articles/24184950644636-Onboarding-a-Client-and-Current-Limitations"})

         ;; PS Unavailable: Show service error empty state
         (= ps-status :ps-unavailable)
         ($ empty-state-view
            {:artwork ConnectionErrorIcon
             :title "Assemble temporarily unavailable"
             :description "We're having trouble connecting to Production Studio. This is usually temporary. Please wait a moment and try again."
             :actions ($ Button
                         {:variant "contained"
                          :onClick refetch-available-third-party-projects}
                         "Retry")})

         ;; Success: Show campaign list
         (= status "success")
         ($ Box {:sx #js {:width "100%"
                          :p 2}}
            (when (pos? campaigns-count)
              ($ Typography
                 (str campaigns-count " social campaign" (if (= 1 campaigns-count) "" "s")
                      " found. Select one to link.")))
            ($ Typography "Ad variant updates will sync automatically.")
            ($ Grid
               {:container true
                :alignContent "left"
                :justifyContent "left"
                :spacing 1.5
                :sx #js {:py 2}}
               (for [c campaigns]
                 ($ ps-project-item (merge c
                                           {:selected-values selected
                                            :selected (contains? selected (:id c))
                                            :disabled (:disabled c)
                                            :value (:id c)
                                            :key (:id c)
                                            :on-click #(let [item (first %)
                                                             items (if (second %)
                                                                     (conj selected item)
                                                                     (disj selected item))]
                                                         (set-selected items))})))))

         ;; Loading: Show spinner
         :else
         ($ loading-view)))))
